import React, { useState, useEffect, useContext } from 'react';
import { addBusinessDays } from 'date-fns';
import Select from 'react-select';
import { useNavigate, useLocation } from 'react-router-dom';
import { Audio } from 'react-loader-spinner';
import { MdOutlineCancel } from 'react-icons/md';
import { BsFillSendFill } from "react-icons/bs";
import { Layout, Header } from '../../../../components';
import { handleApi, formatCurrency, formatMediumDate } from '../../../../utils/utils';
import AppContext from '../../../../contexts/AppContext';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const EditPayment = () => {
  const location = useLocation();
  const { pay } = location.state || {};



  const clearPayeeFields = () => {
    //const method_details = pay?.invoice?.payments?.[0]?.method_details || {};  // Avoid undefined access
    return {
      payee_name: pay?.method_details?.payee_name || '',
      id_no: pay?.method_details?.id_no || '',
      id_type: pay?.method_details?.id_type || '',
      account_holder_name: pay?.method_details?.account_holder_name || '',
      bank_account_number: pay?.method_details?.bank_account_number || '',
      bank_branch: pay?.method_details?.bank_branch || '',
      bank_name: pay?.method_details?.bank_name || '',
      cheque_no: pay?.method_details?.cheque_no || '',
      credit_card_number: pay?.method_details?.credit_card_number || '',
      credit_card_expiration_date: pay?.method_details?.credit_card_expiration_date || '',
      cvv: pay?.method_details?.cvv || '',
      paypal_email: pay?.method_details?.paypal_email || '',
      currency: pay?.method_details?.currency || '',
      mobile_number: pay?.method_details?.mobile_number || '',
      service_provider: pay?.method_details?.service_provider || ''
    };
  };

  
  const [payment, setPayment] = useState({
    
    state: 'draft',
    id:pay?.id || null,
    invoice_id: pay?.invoice_id || null,
    method_id:  pay?.method_id || null,
    amount: pay?.amount|| 0,
    method_details: clearPayeeFields(),  // Calling the function to initialize the payee object
  
  });
  const [invoice, setInvoice] = useState([]);



    const [isLoading, setIsLoading] = useState(false);
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [formattedPaymentMethods, setFormattedPaymentMethods] = useState([]);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null); // The customer object
    const [idTypes, setIdTypes] = useState([]);
    const [formattedIdTypes, setFormattedIdTypes] = useState([]);
    const [selectedIdType, setSelectedIdType] = useState(null); // The customer object
    const [countries, setCountries] = useState([]);
    const [formattedCountries, setFormattedCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null); // The customer object


    const [isInstallment,setIsInstallment] = useState( pay?.invoice?.totalPaidAmount > 0 && pay?.invoice?.totalPaidAmount < pay?.invoice?.totalPriceInclusive);
    const [installments, setInstallments] = useState([]);
    const [showPaymentButton, setShowPaymentButton] = useState(true);
    const { userData, currentColor, actionCount, setActionCount } = useContext(AppContext);
 
    const navigate = useNavigate();
    useEffect(() => {
      const fetchData = async () => {
          try {
              const inv=  await fetchInvoice(); // get invoice
              setIsInstallment((Array.isArray(inv?.payments) && inv?.payments.length > 0||(inv?.totalPaidAmount > 0 && inv?.totalPaidAmount < inv?.totalPriceInclusive)))
              setInvoice(inv)    

              const methods = await fetchPaymentMethods();
              const types = await fetchIdTypes();
              const countries = await fetchCountries();

              // Set the fetched data to the state
              //setFormattedPaymentMethods(paymentMethods);

          
              // Find the selected payment method based on lastPaymentMethodId
              const selectedMethod = methods.find(option => option.value === pay?.method_id);
              setSelectedPaymentMethod(selectedMethod);  // Set the selected payment method to the state
              setFormattedPaymentMethods(methods);

           
             
              const selectedType = types.find(option => option.value === pay?.method_details?.id_type);
              setSelectedIdType(selectedType );  // Set the selected payment method to the state
          } catch (error) {
              console.error('Error fetching data:', error);
          } finally {
              // Mark loading as complete after the fetches are done
              //setLoading(false);
          }
      };

      fetchData();
  }, []); // Empty dependency array ensures this runs only once when the component mounts

  

const fetchInvoice = async () => {
      const apiEndpoint = 'purchase/invoices';
      const apiMethod = 'GET';
      const cleanedData = {};
      const parameters = {id:pay?.invoice_id};
  
      try {
        const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
        if (response.error) {console.error(`Error fetching id types : ${response.errorMessage}`);return;}
        const { status, data } = response;
        if (status === 200) {return data[0] ;} else {toast.error(`Error ${status}: ${response.statusText}`);}
      } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
    };

    const fetchPaymentMethods = async () => {
        const apiEndpoint = 'payment_methods';
        const apiMethod = 'GET';
        const cleanedData = {};
        const parameters = {};
    
        try {
          const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
          if (response.error) {console.error(`Error fetching payment methods: ${response.errorMessage}`);return;}
          const { status, data } = response;
    
          if (status === 200) {
            setPaymentMethods(data);
            const formattedPaymentMethods = data.map(method => ({
             value: method.id,
             label: method.name
            }));
            return formattedPaymentMethods; // Return the formatted data
          } else {toast.error(`Error ${status}: ${response.statusText}`);}
        } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
    };

    const fetchIdTypes = async () => {
          const apiEndpoint = 'id_types';
          const apiMethod = 'GET';
          const cleanedData = {};
          const parameters = {};
      
          try {
            const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
            if (response.error) {
              console.error(`Error fetching id types : ${response.errorMessage}`);
              return;
            }
      
            const { status, data } = response;
         
      
            if (status === 200) {
              const formattedIdTypes = data.map(idTypes => ({
                value: idTypes.name,
                label: idTypes.name
              }));
              return formattedIdTypes 
              //setFormattedIdTypes(formattedIdTypes);
              //setIdTypes(data);
            } else {toast.error(`Error ${status}: ${response.statusText}`);}
          } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
        };
    
        const fetchCountries = async () => {
          const apiEndpoint = 'countries';
          const apiMethod = 'GET';
          const cleanedData = {};
          const parameters = {};
      
          try {
            const response = await handleApi(apiEndpoint, cleanedData, userData, apiMethod, parameters);
            if (response.error) {
              console.error(`Error fetching countries: ${response.errorMessage}`);
              return;
            }
      
            const { status, data } = response;

      
            if (status === 200) {
              const formattedCountry = data.map(country => ({
                value: country.id,
                label: country.currency
              }));
              setFormattedCountries(formattedCountry);
              setCountries(data);
            } else {toast.error(`Error ${status}: ${response.statusText}`);}
          } catch (error) {toast.error(error.message || 'An unexpected error occurred.');}
        };
    
    
    const handlePaymentChange = async (field, value) => {
        setPayment((prevPayment) => {
        let newPayment = { ...prevPayment };
 
        // Handle field updates for the payee object
        if (field === 'bank_account_number') {newPayment.payee = { ...prevPayment.payee, bank_account_number: value };
        } else if (field === 'bank_name') {newPayment.payee = { ...prevPayment.payee, bank_name: value };
        } else if (field === 'bank_branch') {newPayment.payee = { ...prevPayment.payee, bank_branch: value };
        } else if (field === 'account_holder_name') {newPayment.payee = { ...prevPayment.payee, account_holder_name: value };
        } else if (field === 'credit_card_number') {newPayment.payee = { ...prevPayment.payee, credit_card_number: value };
        } else if (field === 'expiration_date') {newPayment.payee = { ...prevPayment.payee, expiration_date: value };
        } else if (field === 'cvv') { newPayment.payee = { ...prevPayment.payee, cvv: value };
        } else if (field === 'currency' ) {
            // Handle currency change here
            newPayment.payee = { ...prevPayment.payee, currency: value.value };  // value.value is the selected currency's value
        } else if (field === 'payee_name') { newPayment.method_details = { ...prevPayment.method_details, payee_name: value };
        }else if (field === 'id_type') { // Find the selected payment method object
          //const selectedId = formattedIdTypes.find(option => option.value === value);
          const selectedId = value;
          newPayment.method_details = { ...prevPayment.method_details, id_type: value.value };
          setSelectedIdType(selectedId);  // Set the object with value and label
          //newPayment.payee = clearPayeeFields();  // Reset all payee fields
        } else if (field === 'id_no') { newPayment.method_details = { ...prevPayment.method_details, id_no: value };
        } else if (field === 'installments') { newPayment.amount = value; 
        }else if (field === 'installment_amount') { newPayment.amount = value; 
        } else if (field === 'method_id') { 
          const selectedMethod = formattedPaymentMethods.find(option => option.value === value);
          newPayment.method_id = value;
          setSelectedPaymentMethod(selectedMethod);  // Set the object with value and label
        } else if (field === 'installments') { setIsInstallment(value);  // Update the installment state
        } else {newPayment[field] = value;   } // If it's not a payee field, update the field directly on payment
 
     return newPayment;
   });
 };
 
    const handleApiWithTimeout = async (url, data, userData, method, parameters, timeout = 5000) => { // Timeout helper for API calls
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), timeout);
  
      try {
        const response = await handleApi(url, data, userData, method, parameters, { signal: controller.signal });
        return response;
      } catch (error) {
        if (error.name === 'AbortError') {
          toast.error('Request timed out');
        } else {
          toast.error('Error: ' + error.message);
        }
        throw error;
      } finally {
        clearTimeout(timeoutId);
      }
    };
  
    const handleSubmit = async () => {
      const selectedMethod= selectedPaymentMethod.label.toLowerCase();
 
      const requiredFields = ['date', 'method_id', 'amount',];
      if (payment.installments && !payment.installment_amount) {toast.error('Please enter the installment amount.');
        return; // Stop the submit if installment amount is missing
      }
      switch(selectedMethod) {
        case 'cash': // Validate bank-transfer related fields
          const cashFields = ['id_no', 'id_type', 'payee_name'];
          for (let field of cashFields) {
            if (!payment.method_details[field]) {
              toast.error(`Please enter ${field}.`);
              return; // Stop the submit if any bank field is missing
            }
          }
          break;
      
        case 'bank transfer': // Validate bank-transfer related fields
          const bankFields = ['bank_account_number', 'bank_name', 'bank_branch', 'account_holder_name'];
          for (let field of bankFields) {
            if (!payment.method_details[field]) {
              toast.error(`Please enter ${field}.`);
              return; // Stop the submit if any bank field is missing
            }
          }
          break;
      
        case 'credit card ': // Validate credit card related fields
          const creditCardFields = ['credit_card_number', 'expiration_date', 'cvv'];
          for (let field of creditCardFields) {
            if (!payment.method_details[field]) {
              toast.error(`Please enter ${field}.`);
              return; // Stop the submit if any credit card field is missing
            }
          }
          break;
      
        case 'paypal': // Validate PayPal related fields
          const paypalFields = ['paypal_email', 'currency'];
          for (let field of paypalFields) {
            if (!payment.method_details[field]) {
              toast.error(`Please enter ${field}.`);
              return; // Stop the submit if any PayPal field is missing
            }
          }
          break;
      
        default:
          // Handle unexpected payment methods
          toast.error("Invalid payment method.");
          return;
      }
      
  
      const cleanedPayee = Object.fromEntries(
        Object.entries(payment.method_details).filter(([key, value]) => value !== '' && value !== null && value !== undefined)
      );
    
    
      delete payment.installment_amount; // remove this field
      const cleanedPayment = { ...payment, state:'draft',method_details: cleanedPayee };// Now update the payment object with the cleaned payee
 
      const parameters = {}; // Make sure this is populated if needed
        setIsLoading(true); // Start loading
    
        try {
          const response = await handleApiWithTimeout('purchase/payments', cleanedPayment, userData, 'PUT', parameters);
   
          if (response.status === 200) {
            // Now update the purchase order state to 'invoiced'
                toast.success('Payment edit successful.');
            // setShowInvoiceButton(false);
          
          } else {toast.error('Failed to edit payment.', response.statusText);}
        } catch (error) {
          console.error("API Error:", error);  // Log any error that might occur
          toast.error('Error editing  purchase payment: ' + error.message);
        } finally {
          setIsLoading(false); // Always stop loading after request is done
          setActionCount(actionCount + 1); // Update action count
        }
      };
    

  const handleClose = () => { 
    navigate(-1);  // Navigate back when closing the form
  };

  const subtotal = pay?.invoice?.totalUntaxedPrice || 0;
  const discountAmount = pay?.invoice?.totalDiscount || 0;
  const subtotalAfterDiscount = subtotal - discountAmount;
  const taxAmount = pay?.invoice?.totalTax || 0;
  const grandTotal = subtotalAfterDiscount + taxAmount;

 
  const formattedGrandTotal = formatCurrency(grandTotal.toFixed(2));

  return (
    <Layout>
      <div className="m-4 bg-black rounded-xl shadow-2xl p-2">
        <ToastContainer position="top-center" autoClose={2000} />
        <div className="text-center py-4 border-b">
          <div className="w-full flex justify-end">
            <button
              className="text-white hover:text-gray-300 py-1 px-2 rounded transition-all duration-300"
              title="Close"
              onClick={handleClose}
            >
              <MdOutlineCancel size={24} color={currentColor}/>
            </button>
          </div>      
          <div className="mx-4 text-white">
            <Header category="Purchase" title="Edit Payment" color={currentColor}/>
          </div>
        </div>        

        {/* Loading State */}
        {isLoading ? (
          <div className="flex flex-col items-center py-6">
            <Audio height="80" width="80" color="white" ariaLabel="loading" />
            <p className="mt-4 text-white">Processing payment...</p>
          </div>
        ) : (
          <div className="bg-white p-6 my-4 rounded-xl shadow-2xl">
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
              
              {/* Supplier Information */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <p className="text-lg text-center font-bold mb-2 uppercase">Supplier Information</p>
                <div className="space-y-1">
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Supplier Name:</label>
                    <span>{invoice?.partners?.name || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Contact Person:</label>
                    <span>{invoice?.partners?.contact_person || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Phone:</label>
                    <span>{invoice?.partners?.phone_number || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Email:</label>
                    <span>{invoice?.partners?.email || 'N/A'}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Invoice No:</label>
                    <span className='font-bold'>{invoice?.invoice_no}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Invoice Date:</label>
                    <span>{formatMediumDate(invoice?.date)}</span>
                  </div>
                </div>
              </div>

              {/* Payment Details */}
              <div className="p-4 bg-gray-50 shadow-md rounded-lg">
                <h3 className="text-lg font-bold text-gray-700 mb-3 uppercase text-center">Invoice information</h3>
                <div className="space-y-2 text-sm">
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Due Date:</label>
                    <span>{formatMediumDate(invoice?.due_date)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <label className="font-medium">Order ID:</label>
                    <span>{invoice?.p_orders?.reference}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Invoice Amount:</span>
                    <span className="font-bold">{formatCurrency(invoice?.totalPriceInclusive || 0)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Total Paid:</span>
                    <span>{formatCurrency(invoice?.totalPaidAmount || 0)}</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Outstanding Balance:</span>
                    <span className="font-bold">{formatCurrency(invoice?.totalPriceInclusive - invoice?.totalPaidAmount || 0)}</span>
                  </div>
                </div>
              </div>
            </div>

            {/* Payment information*/}
            <div className="my-4 pt-1 px-4 pb-4 bg-gray-50 shadow-md rounded-lg">
              <p className="text-lg font-semibold text-gray-800 text-center mb-4 uppercase">Payment Information</p>
                <div className="space-y-4">
                  {/* paying by installent */}
                  <div className=' p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300'>
                    {/* Installment Option */}
                    <div className="flex items-center mb-4">
                      <input
                        type="checkbox"
                        checked={isInstallment}
                        onChange={() => handlePaymentChange('installments', !isInstallment)}  // Call handlePaymentChange with 'installments' field
                        className="mr-2"
                        disabled={isInstallment}
                      />
                      <label className="text-sm text-gray-700 font-bold">Paying in Installments</label>
                    </div>
                    {isInstallment && (
                      <div className='mb-4'>
                        <label className="block text-sm font-bold text-gray-700">Installment Amount</label>
                        <input
                          id="installment_amount"
                          type="number"
                          value={payment.amount || ''}  // Bind amount here since it's the value that's updated
                          placeholder="Enter installment amount"
                          onChange={(e) => handlePaymentChange('installment_amount', parseFloat(e.target.value))}
                          className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                        />
                        <label className="block text-sm font-bold text-gray-700 mt-4">Past Payments</label>
                        <div className="">
                          <div className="overflow-x-auto">
                            {/* Render Table Header only if payments exist */}
                            {invoice.payments.length > 0 && (
                              <div className="flex justify-between items-center py-1 px-4 bg-gray-200 rounded-t-lg">
                                {/* Payment Information Header */}
                                <div className="flex flex-col w-1/3">
                                  <span className="text-sm font-medium text-gray-800">Date</span>
                                </div>

                                {/* Payment Method Header */}
                                <div className="flex flex-col w-1/3">
                                  <span className="text-sm font-medium text-gray-800">Method</span>
                                </div>

                                {/* Payment Amount Header */}
                                <div className="flex flex-col text-right w-1/3">
                                  <span className="text-sm font-medium text-gray-800">Amount</span>
                                </div>

                                {/* Payment Status Header */}
                                <div className="flex flex-col text-right w-1/3">
                                  <span className="text-sm font-medium text-gray-800">Status</span>
                                </div>
                              </div>
                            )}

                            {/* Render Payment Records */}
                            {invoice.payments.length ? (
                              invoice.payments.map((payment, index) => (
                                <div key={index} className="flex justify-between items-center px-4 py-1 bg-gray-100 rounded-lg hover:shadow-lg transition-all duration-300">
                                  {/* date */}
                                  <div className="flex flex-col w-1/3">
                                    <span className="text-xs text-gray-500">{formatMediumDate(payment?.date)}</span>
                                  </div>

                                  {/* Payment Method */}
                                  <div className="flex flex-col w-1/3">
                                    <span className="text-xs text-gray-500 capitalize">
                                      {paymentMethods.find(method => method.id === payment?.method_id)?.name || "N/A"}
                                    </span>
                                  </div>

                                  {/* Payment Amount */}
                                  <div className="flex flex-col text-right w-1/3">
                                    <span className="text-xs text-gray-500">{formatCurrency(payment?.amount)}</span>
                                  </div>

                                  {/* Payment Amount */}
                                  <div className="flex flex-col text-right w-1/3">
                                    <span className="text-xs text-gray-500 capitalize">{payment?.state}</span>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="text-center text-gray-500">No past payments found</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  
                  {/* paymeny method */}
                  <div className=" my-4 p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                    <label className="block text-sm font-bold text-gray-700">Payment Method</label>
                    <Select
                      options={formattedPaymentMethods}
                      value={selectedPaymentMethod}  // Full object with value and label
                      onChange={(selectedPaymentMethod) => handlePaymentChange('method_id', selectedPaymentMethod.value)}
                      className="w-full border border-gray-300 rounded-lg  mt-2 mx-3"
                      placeholder="Select Payment Method"
                    />
                    
             

                    {selectedPaymentMethod && (
                      <>
                      {/* payee information */}
                    <div className='my-2 px-4 bg-gray-25 rounded-lg  hover:shadow-lg transition-all duration-300'>
                      <label className="block text-sm font-bold text-gray-700 my-2 font-bold">PAYEE:</label>   
                      {/* Payment Method is cash  */}
                
                      {/* { selectedMethod.label === 1 && ( */}
                      { selectedPaymentMethod?.label?.toLowerCase() === "cash" && ( 
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          {/*Id Typess*/}
                          <div>
                            <label className="block text-sm font-medium text-gray-700"> ID Type</label>
                            <Select
                              options={formattedIdTypes}
                              value={selectedIdType}  // Full object with value and label
                              onChange={(selectedOption) => handlePaymentChange('id_type', selectedOption)} // Pass the whole selectedOption
                              className="w-full border border-gray-300 rounded-lg mt-2"
                              classNamePrefix="react-select"
                              placeholder="Select Id Type"
                            />
                          </div>

                          {/* Payee */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">ID Number</label>
                            <input
                              type="text"
                              placeholder="Identification #"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              value={payment?.method_details?.id_no}  // Full object with value and label
                              onChange={(e) => handlePaymentChange('id_no', e.target.value)}  // Update the bank account number
                            />
                          </div>

                          {/* Payee name*/}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Payee Full Name</label>
                            <input
                              type="text"
                              placeholder="Enter Full name"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              value={payment?.method_details?.payee_name}  // Full object with value and label
                              onChange={(e) => handlePaymentChange('payee_name', e.target.value)}  // Update the bank account number
                            />
                          </div>
                        </div>
                      )}
                               
                      {/* Payment Method is bank_transfer*/}
                      {payment.method_id === 'bank_transfer' && (
                        <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                          {/* Bank Account Number */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Bank Account Number</label>
                            <input
                            type="text"
                            placeholder="Enter your bank account number"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            onChange={(e) => handlePaymentChange('bank_account_number', e.target.value)}  // Update the bank account number
                            />
                          </div>

                          {/* Bank Name */}
                          <div>
                              <label className="block text-sm font-medium text-gray-700">Bank Name</label>
                              <input
                              type="text"
                              placeholder="Enter the bank name"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('bank_name', e.target.value)}  // Update the bank account number
                              />
                          </div>

                          {/* Bank Branch */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Bank Branch</label>
                            <input
                              type="text"
                              placeholder="Enter the bank branch name"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('bank_branch', e.target.value)}  // Update the bank account number
                            />
                          </div>

                          {/* Account Holder Name */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Account Holder Name</label>
                            <input
                            type="text"
                            placeholder="Enter the account holder's name"
                            className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            onChange={(e) => handlePaymentChange('account_holder_name', e.target.value)}  // Update the bank account number
                            />
                          </div>
                        </div>
                      )}

                      {payment.method_id === 'credit_card' && (
                          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          {/* Credit Card Number */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Credit Card Number</label>
                            <input
                              onChange={(e) => handlePaymentChange('account_holder_name', e.target.value)}  // Update the bank account number
                            />
                            <input
                              type="text"
                              placeholder="Enter your credit card number"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('credit_card_number', e.target.value)}  // Update the bank account number
                            />
                          </div>

                          {/* Expiration Date */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Expiration Date</label>
                            <input
                              type="text"
                              placeholder="MM/YY"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('expiration_date', e.target.value)}  // Update the bank account number
                            />
                          </div>

                          {/* CVV */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">CVV</label>
                            <input
                              type="text"
                              placeholder="Enter the CVV"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('cvv', e.target.value)}  // Update the bank account number
                            />
                          </div>
                        </div>
                      )}

                      {payment.method_id === 'paypal' && (
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                          {/* PayPal Email */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">PayPal Email</label>
                            <input
                              type="email"
                              placeholder="Enter your PayPal email"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                              onChange={(e) => handlePaymentChange('paypal_email', e.target.value)}  // Update the bank account number  
                            />
                          </div>

                          {/* Currency */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Currency</label>
                            <Select
                              options={formattedCountries}
                              onChange={(selectedOption) => handlePaymentChange('currency', selectedOption)} // Pass the whole selectedOption
                              className="w-full border border-gray-300 rounded-lg mt-2"
                              classNamePrefix="react-select"
                              placeholder="Select Currency"
                            />
                          </div>

                          {/* Payee Name */}
                          <div>
                            <label className=" block text-sm font-medium text-gray-700">Payee Name</label>
                            <input
                              type="text"
                              placeholder="Enter the recipient's name"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                        </div>
                      )}

                      {payment.method_id === 'cheque' && (
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2">
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Cheque Number</label>
                            <input
                              type="text"
                              placeholder="Enter cheque number"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Bank Name</label>
                            <input
                              type="text"
                              placeholder="Enter the bank name"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Branch</label>
                            <input
                              type="text"
                              placeholder="Enter the bank branch"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                        </div>
                      )}

                      {payment.method_id === 'mobile_money' && (
                        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-4">
                          {/* Mobile Number */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Mobile Number</label>
                            <input
                              type="text"
                              placeholder="Enter your mobile number"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                          {/* Service Provider */}
                          <div>
                            <label className="block text-sm font-medium text-gray-700">Service Provider</label>
                            <input
                              type="text"
                              placeholder="Enter the mobile service provider"
                              className="w-full border border-gray-300 rounded-lg px-4 py-2 mt-2 text-gray-700"
                            />
                          </div>
                        </div>
                      )}
                    </div>
                    {/* end  payee information */}
                      </>
                        
                    
                    )}
                    
                    
                  </div>  
                </div>
              </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-4 mt-4">
                <button
                    onClick={handleSubmit}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    <BsFillSendFill size={20} />
                    <span>Submit</span>
                </button>

                <button
                    onClick={handleClose}
                    className="bg-blue-500 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center gap-2"
                >
                    <MdOutlineCancel size={20} />
                    <span>Close</span>
                </button>
            </div>    
        </div>
    )}
</div>
</Layout>
);
};

export default EditPayment;
